"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS = exports.STATUS_INDICATOR_MIN_WIDTH = exports.STATUS_INDICATOR_GAP = void 0;
var STATUS_INDICATOR_GAP = 8;
exports.STATUS_INDICATOR_GAP = STATUS_INDICATOR_GAP;
var STATUS_INDICATOR_MIN_WIDTH = 112;
exports.STATUS_INDICATOR_MIN_WIDTH = STATUS_INDICATOR_MIN_WIDTH;
var STATUS = Object.freeze({
  POSITIVE: 'positive',
  WARNING: 'warning',
  NEGATIVE: 'negative',
  NEUTRAL: 'neutral',
  INFORMATION: 'information',
  WAITING: 'waiting',
  UNAVAILABLE: 'unavailable'
});
exports.STATUS = STATUS;